import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/api/client";
import { todayIstIso } from "@/utils/date";

const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const nextMonday = (iso) => { const d = new Date(`${iso}T12:00:00`).getDay(); return addDays(iso, ((8 - d) % 7) || 7); };

// Moves a hot lead's next action date (for everyone) so the reminder returns that day.
export function RemindLaterForm({ leadId, onDone, onCancel }) {
  const today = todayIstIso();
  const picks = [["Tomorrow", addDays(today, 1)], ["In 3 days", addDays(today, 3)], ["Next Monday", nextMonday(today)]];
  const [date, setDate] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post(`/hot-leads/${leadId}/snooze`, { date });
      const [y, m, d] = date.split("-");
      toast.success(`Will remind everyone on ${d}/${m}/${y.slice(2)}`); onDone?.();
    } catch (x) { toast.error(formatApiError(x?.response?.data?.detail) || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="mt-2 space-y-2" data-testid={`remind-later-form-${leadId}`}>
      <div className="text-xs text-white/60">Remind again on (moves the next action date for everyone)</div>
      <div className="flex flex-wrap gap-1.5">
        {picks.map(([l, v], i) => (
          <button key={l} type="button" onClick={() => setDate(v)} data-testid={`remind-later-pick-${leadId}-${i}`}
            className={`h-7 px-2 rounded-full border text-[11px] transition-colors ${date === v ? "border-[#E11D2E] bg-[#E11D2E]/10 text-[#E11D2E]" : "border-white/15 hover:bg-white/5"}`}>{l}</button>
        ))}
        <input type="date" value={date} min={addDays(today, 1)} onChange={(e) => setDate(e.target.value)} data-testid={`remind-later-date-${leadId}`}
          className="h-7 rounded-md border border-white/15 bg-transparent px-2 text-[11px] text-white" />
      </div>
      <div className="flex gap-2">
        <button type="submit" disabled={busy || !date} data-testid={`remind-later-save-${leadId}`}
          className="h-8 px-3 rounded-md bg-[#E11D2E] hover:bg-[#F03041] text-white text-xs font-semibold disabled:opacity-50 inline-flex items-center gap-1"><CalendarClock size={12} /> Set reminder</button>
        <button type="button" onClick={onCancel} data-testid={`remind-later-cancel-${leadId}`} className="h-8 px-3 rounded-md border border-white/15 text-xs">Back</button>
      </div>
    </form>
  );
}
